import React from 'react'
import SignInImageView from "../components/SignInImageView.js"
import SignUpStatement from '../components/SignUpStatement.js'
import "../styles/SingIn.css";


function SignIn() {
  return (
    <div className='signin-main-container'>
      <div className='signin-image-view-container'><SignInImageView /></div>
      <div className='signin-window-container'><SignUpStatement /></div>
    </div>
  )
}

export default SignIn